import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { DealsWizardModel, DealSignatureModel } from '../../../_models/_index';
import { DealStepEnum, DealStatusEnum, AlertDialogConfirmTypeEnum} from '../../../_enums/_index';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { GeneralService ,UserService} from '../../../services/_index';
import { MatDialog, MatDialogRef } from '@angular/material';
import { SignatureDialogComponent } from './signature-dialog/signature-dialog.component';

@Component({
    selector: 'deal-approval',
    moduleId: module.id,
    templateUrl: 'deal-approval.component.html'

})
export class DealApprovalComponent implements OnInit {
    tzHasError: boolean = false;
    year: string;
    month: string;
    fileToUpload: File;
    url: any;
    isEmpty: boolean = true;
    @Input()
    loading: boolean;

    @Input()
    dealsWizard: DealsWizardModel;

    @Input()
    dealStep: DealStepEnum;

    @Output()
    saveOrderEvent: EventEmitter<DealsWizardModel>;

    @Output()
    nextStepEvent: EventEmitter<DealStepEnum>;


    editCompany: boolean = false;
    editContact: boolean = false;
    editPayment: boolean = false;

    
    constructor(private dialog: MatDialog,
        private generalService: GeneralService,
        private userService: UserService
    ) {
        this.nextStepEvent = new EventEmitter<DealStepEnum>();
        this.saveOrderEvent = new EventEmitter<DealsWizardModel>();
    }

    ngOnInit() {
        if (this.userService.isCustomer()) {
            if (this.dealsWizard.statusID <= DealStatusEnum.Opened)
                this.dealsWizard.signedDate =new Date();
        }

        if (this.dealsWizard.creditCardExpiryDate) {
            this.month = this.dealsWizard.creditCardExpiryDate.substring(0, 2);
            this.year = this.dealsWizard.creditCardExpiryDate.substring(2);
        }
    }

    ngOnChanges() {

    }

    isCustomer() {
        return this.userService.isCustomer();
    }

    prevStep() {
        this.dealStep = this.dealStep - 1;
        this.nextStepEvent.emit(this.dealStep);
    }

    validate() {
        let validate: boolean = true;

        validate = !this.dealsWizard.contactIdentityNumber || this.validateTZ(this.dealsWizard.contactIdentityNumber);
        validate = validate && this.validateEmail();

        return validate;
    }

    validateEmail() {
        var email = this.dealsWizard.email;
        var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
        if (email == '' || !re.test(email)) {

            return false;
        }
        return true;
    }

    validateTZ(num) {
        this.tzHasError = !this.generalService.validateTZ(num);

        return !this.tzHasError;
    }

    saveOrder() {
        if (this.validate()) {
            debugger;
            let canSave = true;
            switch (this.dealsWizard.statusID) {
                case 1:
                    this.generalService.showConfirmDialog("האם אתה בטוח שברצונך לשלוח חוזה ללקוח?", AlertDialogConfirmTypeEnum.YesNo).then(result => {
                        if (result) {
                            this.dealsWizard.createDate = new Date();
                            this.dealsWizard.pageNumber = 0;
                            this.dealsWizard.creatorID = this.userService.getCurrentUser().id;
                            this.dealsWizard.lastUpdate = new Date();

                            this.saveOrderEvent.emit(this.dealsWizard);
                        }
                    });


                    break;
                case 2:
                case 3:
                    if (this.userService.isCustomer()) {
                        if (this.isEmpty) {
                            this.generalService.showErrorDialog("חובה לחתום על ההזמנה");
                            canSave = false;
                        }
                        else {
                            this.dealsWizard.isSignedFromMobile = this.getIsSignedFromMobile();

                            this.dealsWizard.lastUpdate = new Date();
                            this.dealsWizard.signedDate = new Date();
                            this.dealsWizard.pageNumber = 5;
                            this.saveOrderEvent.emit(this.dealsWizard);
                        }
                    }
                    else
                    {
                        this.saveOrderEvent.emit(this.dealsWizard);
                    }
                    break;
            }
        }
        
    }

    getIsSignedFromMobile()
    {
        const mq = window.matchMedia("(max-width: 600px)");
        if (mq.matches)
        {
            return true;
        }
        return false;
    }

    isReadOnly() {
        return this.dealsWizard.statusID > 3;
    }

    isRequired()
    {
        return this.userService.isCustomer() && this.dealsWizard.statusID == 3 && !this.dealsWizard.isTrial && this.dealsWizard.paymentType == 1;
    }

    isDetailsRequired()
    {
        return this.userService.isCustomer();
    }

    openSignDialog()
    {
        let dialogRef = this.dialog.open(SignatureDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'חתימה';
        dialogRef.componentInstance.dealsWizard = this.dealsWizard;
        dialogRef.afterClosed().subscribe((result: DealSignatureModel) => {
            if (result) {
                this.dealsWizard.fileToUpload = result.fileToUpload;
                if(result.fileToUpload)
                    this.dealsWizard.companySignatureType = result.fileToUpload.type;
                this.dealsWizard.signature = result.signature;
                this.isEmpty = result.isEmpty;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-approval/deal-approval.component.ts